import { useEffect, useRef, useState } from 'react';
import 'intersection-observer';
import { useVisibilitySensor } from '../../visibility-sensor';
import { eventFactory } from '../helpers/eventFactory';
import { getHorizontalScrollItems } from '../helpers/getHorizontalScrollItems';
export const useFireEvents = ({ ref }) => {
    const [isVisible, setIsVisible] = useState(false);
    const state = useRef({
        progress: 0,
        hasScrolled: false,
        direction: 'right',
    });
    const handleProgress = (progress) => {
        state.current.direction = progress < state.current.progress ? 'left' : 'right';
        state.current.progress = progress;
    };
    const setHasScrolled = (hasScrolled) => {
        state.current.hasScrolled = hasScrolled;
    };
    useVisibilitySensor({
        onChange: setIsVisible,
        ref,
        threshold: 0.5,
        notifyVisibleOnce: true,
    });
    useEffect(() => {
        if (!ref.current || !isVisible) {
            return () => { };
        }
        const horizontalScrollItems = getHorizontalScrollItems(ref.current);
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                var _a;
                if (entry.isIntersecting) {
                    const event = eventFactory({
                        target: entry.target,
                        hasScrolled: state.current.hasScrolled,
                        direction: state.current.direction,
                        total: horizontalScrollItems.length,
                    });
                    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(event);
                }
            });
        }, { root: ref.current });
        horizontalScrollItems.forEach((horizontalScrollItem, index) => {
            // eslint-disable-next-line no-param-reassign
            horizontalScrollItem.dataset.index = `${index}`;
            observer.observe(horizontalScrollItem);
        });
        return () => {
            observer.disconnect();
        };
    }, [ref, isVisible]);
    return {
        setHasScrolled,
        handleProgress,
    };
};
